<template>
  <div>
    <div id="query">
      <Check></Check>
    </div>
    <div class="c-container-box">
      <el-tabs type="card">
        <el-tab-pane label="查询结果">
          <ResCheck></ResCheck>
        </el-tab-pane>
        <el-tab-pane label="配置管理">
          <MonitorConfig></MonitorConfig>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

</template>

<script>
import Check from './components/check.vue';
import MonitorConfig from './components/monitorConfig.vue';
import ResCheck from './components/resCheck.vue';
export default {
  data() {
    return {


    }
  },
  components: {
    Check, MonitorConfig, ResCheck
  },
  computed: {

  },
  watch: {
    '$store.state.curTreeData': {
      handler(val) {

      }
    },


  },
  methods: {


  },
  ready() {

  },
  mounted() {
    this.ws.addCallback('checkGroupReady', (res) => {
      console.log(467, res);

    })


  },
}
</script>

<style lang="scss">
.c-container-box {
  height: calc(100vh - 270px);
}
</style>